import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import { get_token, get_user_details } from "@/router";

import { merge_campaign_collections } from "./donation_campaigns_helper";
import { matches_campaign_query } from "./donation_campaigns_form_helper";
import { campaign_view_methods, get_selected_campaign_donations } from "./donation_campaigns_view_helper";
import { get_campaign_comments } from "./donation_campaigns_comments_helper";
import { get_campaign_supporting_files } from "./donation_campaigns_methods_helper";

export default {
  name: "DonationCampaignsView",
  components: {
    HomeNavBar,
    InactivityModal,
  },
  data() {
    return ({
      token_exists: false,
      payfast: process.env.VUE_APP_PAYFAST_URL,
      user_details: {
        user_role: "",
        first_name: "",
        last_name: "",
        user_id: "",
      },
      active_tab: "explore",
      search_query: "",
      public_campaigns: [],
      my_campaigns_data: [],
      selected_campaign_id: null,
      mobile_description_expanded: false,
      detail_tab: "donors",
      comment_form: {
        comment: "",
      },
      comment_errors: {
        comment: "",
      },
      expanded_comments: {},
      editing_comment_id: null,
      is_submitting_comment: false,
      donor_sort: "highest",
      donor_page: 1,
      donor_page_size: 6,
      is_loading_public: false,
      is_loading_my_campaigns: false,
      load_error_message: "",
      is_processing_donation: false,
      donation_campaign: null,
      donation_form: {
        amount: "",
        message: "",
        is_anonymous: false,
      },
      donation_errors: {
        amount: "",
      },
      donation_amount_presets: [100, 250, 500, 1000],
      preview_file: null,
    });
  },
  computed: {
    page_loading() {
      return this.is_loading_public || (this.token_exists && this.is_loading_my_campaigns);
    },
    all_campaigns() {
      return merge_campaign_collections([...this.my_campaigns_data, ...this.public_campaigns]);
    },
    selected_campaign() {
      return (
        this.all_campaigns.find((campaign) => Number(campaign.id) === Number(this.selected_campaign_id)) ||
        this.all_campaigns[0] ||
        null
      );
    },
    active_campaigns() {
      return this.public_campaigns;
    },
    filtered_campaigns() {
      const query = String(this.search_query || "").trim().toLowerCase();
      return this.active_campaigns.filter((campaign) => matches_campaign_query(campaign, query));
    },
    show_explore_loader() {
      return this.active_tab === "explore" && this.page_loading && !this.public_campaigns.length;
    },
    show_detail_loader() {
      return this.active_tab === "detail" && this.page_loading && !this.selected_campaign;
    },
    selected_donation_campaign() {
      return this.donation_campaign || this.selected_campaign || null;
    },
    selected_campaign_donations() {
      return get_selected_campaign_donations(this.selected_campaign, this.donor_sort);
    },
    selected_campaign_donor_count() {
      return this.selected_campaign_donations.length;
    },
    selected_campaign_supporting_files() {
      return get_campaign_supporting_files(this.selected_campaign);
    },
    selected_campaign_comments() {
      return get_campaign_comments(this.selected_campaign);
    },
    paginated_campaign_donations() {
      const start_index = (this.donor_page - 1) * this.donor_page_size;
      const end_index = start_index + this.donor_page_size;
      return this.selected_campaign_donations.slice(start_index, end_index);
    },
    donor_total_pages() {
      return Math.max(1, Math.ceil(this.selected_campaign_donations.length / this.donor_page_size));
    },
  },
  watch: {
    "$route.query.campaign_id"() {
      this.sync_page_state();
    },
    detail_tab() {
      this.donor_page = 1;
    },
    donor_sort() {
      this.donor_page = 1;
    },
  },
  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details() || this.user_details;
    this.sync_page_state();
    this.load_campaign_data();
  },
  methods: {
    ...campaign_view_methods,
  },
};
